<script setup>
import { computed } from 'vue'
import store from '@/user/store'

const footerVisible = computed(() => store.getters['GlobalStore/footerVisible'])
const isVisible = footerVisible.value === true
</script>

<template><div v-if="isVisible">Footer</div></template>
